import * as Sentry from '@sentry/react'
import { Button } from 'primereact/button'
import { AnyAction } from '@reduxjs/toolkit'
import { useNavigate } from 'react-router-dom'
import { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  checkIfTimerIsSetRequest,
  fetchGameCodeRequest,
  fetchWelcomeScreenRequest,
} from '../../../redux/actions/gameActions'
import * as DOMPurify from 'dompurify'
import { getGameSelector } from './../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import Loading from '../../../components/Loading'
import GameHeader from '../components/GameHeader'
import jwt_decode from 'jwt-decode'
import { Game } from 'iconsax-react'
import useSound from 'use-sound'
import { useTranslation } from 'react-i18next'
import Consent from '../components/Consent'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const Welcome = () => {
  const {
    data: {
      welcomeScreen,
      collectedItems,
      gameCode,
      teamName,
      volumeGlobal,
      selectedLanguage,
      branding,
    },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const navigate = useNavigate()
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  // const [flag, setFlag] = useState(false)
  const { t } = useTranslation()

  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { GameLogo, GameType }: any = jwt_decode(token)

  useEffect(() => {
    if (selectedLanguage) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dispatch(fetchWelcomeScreenRequest(selectedLanguage.id))
      dispatch(fetchGameCodeRequest())
    }

    Sentry.captureMessage('Uslo Welcome useEffect[]', 'warning')
    Sentry.setContext('Variables', {
      token: localStorage.getItem('tokenCityHunt'),
      selectedLanguage,
    })
  }, [selectedLanguage])

  // useEffect(() => {
  //   if (flag) throw new Error('Something went wrong!')
  // }, [flag])

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  if (gameLoading.isLoadingWelcomeScreen || !welcomeScreen) {
    return <Loading />
  }

  Sentry.setContext('Variables', {
    gameType: GameType,
  })

  // const handleErorr = () => {
  //   setFlag(true)
  // }

  return (
    <>
      {selectedLanguage && <Consent />}
      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore */}
      <GameHeader
        collectedItems={collectedItems}
        gameLoading={gameLoading}
        gameLogo={GameLogo}
        gameCode={gameCode}
        hasInventory={false}
        teamName={teamName}
        volumeGlobal={volumeGlobal}
        gameType={GameType}
      />
      {/* <div className="flex"> */}
      {/* <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="/assets/layout/images/game-map.svg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{
              // clipPath: 'polygon(8% 0, 100% 0%, 100% 100%, 0 100%)',
              width: 'inherit',
            }}
          />
        </div> */}
      <div className="p-3 text-center flex flex-column align-items-center ">
        {/* <section> */}
        {/* <span className="block text-6xl font-bold mb-1">Welcome Player</span>
          <div className="text-6xl text-primary font-bold mb-3">
            your game instructions are here
          </div>
          <p className="mt-0 mb-4 text-700 line-height-3">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p> */}

        {/* <Language /> */}

        <div
          className="mt-3 img-full-width ql-editor"
          style={{ overflowWrap: 'break-word' }}
          dangerouslySetInnerHTML={sanitizedData(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            decodeIframeString(welcomeScreen?.html ?? '') ?? '',
          )}
        />
        {/* <button type="button" onClick={handleErorr}>
          Break the world
        </button> */}
        <Button
          label={t('StartGame')}
          onClick={() => {
            clickSound()
            navigate('/game')
            dispatch(checkIfTimerIsSetRequest())
          }}
          type="button"
          className="p-button-rounded mt-4 py-3 zoominleft animation-duration-1000 uppercase w-full"
          // className="p-button-rounded mt-5 py-3 zoominleft animation-duration-1000 uppercase w-full"
          // className="p-button-rounded mt-5 p-button-raised w-full sign-in-btn zoominleft animation-duration-1000"
          // icon={<Game color="#fff" variant="Bold" className="mr-1" />}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <Game
                color={branding?.buttonPrimary.backgroundColor}
                variant="Bold"
                className="icon-center"
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
          // style={{ padding: '1.3rem 0' }}
        />
        {/* <Button
            label="Play Game"
            onClick={() => navigate('/game')}
            type="button"
            className="p-button-outlined"
          /> */}
        {/* </section> */}
      </div>
      {/* </div> */}
    </>
  )
}

export default Welcome
